// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  domain: "",
  apiUrl: "https://rydigo.in:3000",
  socketUrl: "https://rydigo.in:8081",
  googleapiKey: "AIzaSyA5MNpH_A3wGbC8aaY5mn1VkJgO71fe9zQ",
  googleloginClientid: "759646408584-1sstaa63e83vvloam8tbhcv8qsc96dte.apps.googleusercontent.com",
  facebookloginClientid: "",
  firebase: {
    apiKey: "AIzaSyBnk0RLaUEtf7mUvGd2ax03iAbI4TAzERg",
    authDomain: "trim-hash-464012-k4.firebaseapp.com",
    databaseURL: "https://trim-hash-464012-k4-default-rtdb.firebaseio.com",
    projectId: "trim-hash-464012-k4",
    storageBucket: "trim-hash-464012-k4.firebasestorage.app",
    messagingSenderId: "638921066019",
    appId: "1:638921066019:web:1aadc9001379e324e01396",
  }
};


